export var DashboardType;
(function (DashboardType) {
    DashboardType[DashboardType["OVERVIEW"] = 1] = "OVERVIEW";
    DashboardType[DashboardType["REPORTING"] = 2] = "REPORTING";
    DashboardType[DashboardType["BILLING"] = 3] = "BILLING";
})(DashboardType || (DashboardType = {}));
